import React from "react";
import theme from "theme";
import { Theme, Link, Image, LinkBox, Structure, Box, Text, Icon, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import { BsDot } from "react-icons/bs";
import { MdPhone } from "react-icons/md";
import { FaFacebook, FaInstagram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Beesmoor Property
			</title>
			<meta name={"description"} content={"Bristol based Rent-to-Rent specialists"} />
			<meta property={"og:title"} content={"Beesmoor Property"} />
			<meta property={"og:description"} content={"Bristol based Rent-to-Rent specialists"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL_Favicon.png?v=2025-09-24T19:30:49.126Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL_Favicon.png?v=2025-09-24T19:30:49.126Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL_Favicon.png?v=2025-09-24T19:30:49.126Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL_Favicon.png?v=2025-09-24T19:30:49.126Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL_Favicon.png?v=2025-09-24T19:30:49.126Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL_Favicon.png?v=2025-09-24T19:30:49.126Z"} />
		</Helmet>
		<Structure cells-number-total="3">
			<Override slot="Content">
				<Override slot="cell-2">
					<Structure cells-number-total="6">
						<Override slot="Content">
							<Override slot="cell-0">
								<Link href="#" color="#000000" font="16px --fontFamily-googleZenKakuGothicNew" text-decoration-line="initial">
									Home
								</Link>
							</Override>
							<Override slot="cell-1">
								<Link href="#" color="#000000" font="16px --fontFamily-googleZenKakuGothicNew" text-decoration-line="initial">
									Landlords
								</Link>
							</Override>
							<Override slot="cell-2">
								<Link href="#" color="#000000" font="16px --fontFamily-googleZenKakuGothicNew" text-decoration-line="initial">
									Agents
								</Link>
							</Override>
							<Override slot="cell-3">
								<Link href="#" color="#000000" font="16px --fontFamily-googleZenKakuGothicNew" text-decoration-line="initial">
									About
								</Link>
							</Override>
							<Override slot="cell-4">
								<LinkBox href="https://www.facebook.com/profile.php?id=61579952348050" target="_blank">
									<Image src="https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20:13:30.439Z" display="block" srcSet="https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20%3A13%3A30.439Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20%3A13%3A30.439Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20%3A13%3A30.439Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20%3A13%3A30.439Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20%3A13%3A30.439Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20%3A13%3A30.439Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/facebook-gold-small.png?v=2025-08-28T20%3A13%3A30.439Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw" />
								</LinkBox>
							</Override>
							<Override slot="cell-5">
								<LinkBox target="_blank">
									<Image src="https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20:13:15.904Z" display="block" srcSet="https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20%3A13%3A15.904Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20%3A13%3A15.904Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20%3A13%3A15.904Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20%3A13%3A15.904Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20%3A13%3A15.904Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20%3A13%3A15.904Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/instagram-gold%20small.png?v=2025-08-28T20%3A13%3A15.904Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw" />
								</LinkBox>
							</Override>
						</Override>
					</Structure>
				</Override>
				<Override slot="cell-0">
					<Image src="https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21:57:54.223Z" display="block" srcSet="https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw" />
				</Override>
				<Override slot="cell-1">
					<Box min-width="100px" min-height="100px" />
				</Override>
			</Override>
		</Structure>
		<Section padding="0 0 0 0" quarkly-title="Hero-13">
			<Override slot="SectionContent" width="100%" flex-direction="row" max-width="100%" />
			<Box
				min-width="100px"
				min-height="100px"
				display="flex"
				justify-content="space-around"
				lg-flex-direction="column"
			>
				<Image
					src="https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21:01:12.940Z"
					display="block"
					width="40%"
					object-fit="cover"
					height="100%"
					lg-width="100%"
					lg-height="700px"
					sm-height="500px"
					srcSet="https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21%3A01%3A12.940Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21%3A01%3A12.940Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21%3A01%3A12.940Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21%3A01%3A12.940Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21%3A01%3A12.940Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21%3A01%3A12.940Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/green%20door%202.jpg?v=2025-08-28T21%3A01%3A12.940Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
				/>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="flex-start"
					justify-content="flex-end"
					width="60%"
					padding="80px 80px 80px 80px"
					lg-width="100%"
					md-padding="50px 50px 80px 50px"
					sm-padding="50px 25px 80px 25px"
				>
					<Box
						min-width="10px"
						min-height="10px"
						display="flex"
						align-items="center"
						margin="0px 0px 25px 0px"
						sm-flex-direction="column"
						sm-align-items="flex-start"
					>
						<Text
							margin="0px 7px 0px 0px"
							font="normal 400 16px/1.5 --fontFamily-sans"
							color="#061e11"
							sm-margin="0px 0 7px 0px"
							letter-spacing="1px"
						>
							RENT-TO-RENT SPECIALIST
						</Text>
						<Icon
							category="bs"
							icon={BsDot}
							size="24px"
							margin="0px 7px 0px 0px"
							sm-display="none"
						/>
						<Text margin="0px 0px 0px 0px" font="normal 400 16px/1.5 --fontFamily-sans" color="#061e11" letter-spacing="1px">
							GUARANTEED INCOME
						</Text>
					</Box>
					<Text
						margin="0px 0px 40px 0px"
						font="normal 500 72px/1.2 --fontFamily-googleZenKakuGothicNew"
						color="#061e11"
						lg-margin="0px 0px 35px 0px"
						md-font="normal 500 52px/1.2 --fontFamily-serifGeorgia"
						sm-font="normal 500 42px/1.2 --fontFamily-serifGeorgia"
					>
						STRESS FREE PROPERTY MANAGEMENT FOR LANDLORDS
					</Text>
					<Link href="#" color="#CC9900" font="normal 600 28px/1.2 --fontFamily-googleZenKakuGothicNew">
						CONTACT US
					</Link>
				</Box>
			</Box>
		</Section>
		<Section padding="80px 0 90px 0" quarkly-title="Product-3" background="#f3eee8">
			<Override slot="SectionContent" align-items="center" />
			<Text
				margin="0px 0px 20px 0px"
				font="normal 600 36px/1.2 --fontFamily-sans"
				text-align="center"
				lg-width="70%"
				md-width="100%"
			>
				Your trusted partner in Rent-to-Rent Property Management{" "}
			</Text>
			<Text
				margin="0px 0px 70px 0px"
				text-align="center"
				font="normal 300 22px/1.5 --fontFamily-sansHelvetica"
				color="#7c7f81"
				padding="0px 280px 0px 280px"
				lg-padding="0px 0 0px 0"
				lg-margin="0px 0px 50px 0px"
			>
				Beesmoor Property specialises in providing high-quality short-term accommodation for the professional employees of leading local businesses.
			</Text>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				grid-template-rows="auto"
				grid-gap="0 35px"
				md-grid-template-columns="1fr"
				md-grid-gap="40px 0"
				margin="0px 0px 50px 0px"
				md-margin="0px 0px 50px 0px"
			>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Image
						src="https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000"
						display="block"
						max-width="100%"
						margin="0px 0px 25px 0px"
						height="300px"
						width="100%"
						object-fit="cover"
						sm-height="220px"
						srcSet="https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
					<Text margin="0px 0px 15px 0px" color="#cc9900" font="normal 600 26px/1.5 --fontFamily-googleZenKakuGothicNew">
						GUARANTEED RENTAL
					</Text>
					<Text margin="0px 0px 15px 0px" font="normal 300 22px/1.2 --fontFamily-sansHelvetica" text-align="center" color="#7c7f81">
						Your rental income is guaranteed for the full duration of the agreement.
						<br />
						Typical terms are 3-5yrs.
					</Text>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Image
						src="https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000"
						display="block"
						max-width="100%"
						margin="0px 0px 25px 0px"
						height="300px"
						width="100%"
						object-fit="cover"
						sm-height="220px"
						srcSet="https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=500 500w,https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=800 800w,https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1080 1080w,https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1600 1600w,https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2000 2000w,https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2600 2600w,https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
					<Text margin="0px 0px 15px 0px" color="#cc9900" font="normal 600 26px/1.5 --fontFamily-googleZenKakuGothicNew">
						FREE REFURBISHMENT
					</Text>
					<Text margin="0px 0px 15px 0px" font="normal 300 22px/1.2 --fontFamily-sansHelvetica" text-align="center" color="#7c7f81">
						Our team will conduct a free cosmetic make-over and provide the furniture to ensure the property reaches the high standards we require for our clients.
					</Text>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Image
						src="https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000"
						display="block"
						max-width="100%"
						margin="0px 0px 25px 0px"
						height="300px"
						width="100%"
						object-fit="cover"
						sm-height="220px"
						srcSet="https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
					<Text margin="0px 0px 15px 0px" color="#cc9900" font="normal 600 26px/1.5 --fontFamily-googleZenKakuGothicNew">
						ONWARD OPTIONS
					</Text>
					<Text margin="0px 0px 15px 0px" font="normal 300 22px/1.2 --fontFamily-sansHelvetica" text-align="center" color="#7c7f81">
						At the end of the agreement multiple options exist including renewing the agreement, taking back your well maintained property or we could even offer to purchase your home.
					</Text>
				</Box>
			</Box>
		</Section>
		<Section
			padding="90px 0 50px 0"
			background="--color-dark"
			quarkly-title="Footer-13"
			sm-padding="50px 0 50px 0"
			text-align="center"
		>
			<Box
				min-width="100px"
				min-height="100px"
				padding="50px 30px 50px 30px"
				background="linear-gradient(180deg,rgba(255, 255, 255, 0.2) 0.5%,rgba(255, 255, 255, 0.15) 99%) 0 0 no-repeat,#898e77"
				display="flex"
				justify-content="space-around"
				align-items="center"
				margin="0px 0px 80px 0px"
				md-flex-direction="column"
				md-align-items="stretch"
				md-margin="0px 0px 50px 0px"
				md-padding="30px 30px 30px 30px"
				sm-padding="20px 15px 20px 15px"
			>
				<Box
					min-width="100px"
					min-height="100px"
					width="60%"
					md-margin="0px 0px 30px 0px"
					md-width="100%"
					sm-margin="0px 0px 18px 0px"
				>
					<Text
						margin="0px 0px 20px 0px"
						font="normal 900 42px/1.2 --fontFamily-googleZenKakuGothicNew"
						color="--darkL2"
						md-margin="0px 0px 15px 0px"
						sm-margin="0px 0px 12px 0px"
					>
						Call us for a chat
					</Text>
					<Text margin="0px 0px 0px 0px" color="--darkL2" font="normal 500 28px/1.2 --fontFamily-googleZenKakuGothicNew">
						Let's find the best solution for you
					</Text>
				</Box>
				<LinkBox
					flex-direction="row"
					padding="15px 25px 15px 25px"
					border-width="2px"
					border-style="solid"
					border-color="--color-darkL2"
					background="#f3eee8"
					sm-padding="10px 15px 10px 15px"
					href="tel:+447894205657"
				>
					<Icon
						category="md"
						icon={MdPhone}
						size="24px"
						color="--darkL2"
						margin="0px 8px 0px 0px"
					/>
					<Text margin="0px 0px 0px 0px" font="normal 500 20px/1.5 --fontFamily-sans" color="--darkL2" border-color="#979290">
						+44 (0)7894 205657
					</Text>
				</LinkBox>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="16px 24px"
				margin="0px 0px 80px 0px"
				md-grid-template-columns="1fr"
				md-grid-gap="36px 0"
				md-margin="0px 0px 50px 0px"
			>
				<Box min-width="100px" min-height="100px">
					<Text
						margin="0px 0px 25px 0px"
						font="normal 500 24px/1.2 --fontFamily-sansHelvetica"
						text-align="center"
						color="#cc9900"
						md-margin="0px 0px 20px 0px"
					>
						Beesmoor Property Ltd
					</Text>
					<Text
						margin="0px 0px 20px 0px"
						color="#d7c7c5"
						font="normal 300 18px/1.5 --fontFamily-sans"
						text-align="center"
						border-color="#b8acac"
						md-margin="0px 0px 15px 0px"
					>
						104 Beesmoor Road, BS36 2JP
					</Text>
					<Box
						min-width="10px"
						min-height="10px"
						display="flex"
						grid-template-columns="repeat(5, 1fr)"
						grid-gap="16px 24px"
						md-align-self="flex-start"
						sm-align-self="center"
						justify-items="start"
						justify-content="center"
					>
						<LinkBox href="https://www.facebook.com/profile.php?id=61579952348050" target="_blank">
							<Icon
								category="fa"
								icon={FaFacebook}
								size="24px"
								color="--light"
								hover-color="--lightD2"
								transition="background-color 1s ease 0s"
							/>
						</LinkBox>
						<LinkBox href="/">
							<Icon
								category="fa"
								icon={FaInstagram}
								size="24px"
								color="--light"
								hover-color="--lightD2"
								transition="background-color 1s ease 0s"
							/>
						</LinkBox>
					</Box>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Text
						margin="0px 0px 25px 0px"
						font="normal 500 24px/1.2 --fontFamily-sansHelvetica"
						text-align="center"
						color="#cc9900"
						md-margin="0px 0px 20px 0px"
					>
						Contact us
					</Text>
					<Link
						href="tel:+4407894205657"
						color="#d7c7c5"
						text-decoration-line="initial"
						font="normal 300 18px/1.5 --fontFamily-sans"
						display="flex"
						text-align="center"
						margin="0px 0px 15px 0px"
						hover-color="#f5eceb"
					>
						+44 (0) 7894 205657
					</Link>
					<Link
						color="#d7c7c5"
						text-decoration-line="initial"
						font="normal 300 18px/1.5 --fontFamily-sans"
						display="flex"
						margin="0px 0px 15px 0px"
						text-align="center"
						hover-color="#f5eceb"
						href="info@beesmoorproperty.co.uk"
						target="_blank"
					>
						info@beesmoorproperty.co.uk
					</Link>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Image
						src="https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21:57:54.223Z"
						display="block"
						text-align="center"
						srcSet="https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/BPL25-1small.png?v=2025-08-27T21%3A57%3A54.223Z&quality=85&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
					<Structure cells-number-total="2" text-align="center">
						<Override
							slot="Content"
							display="flex"
							text-align="center"
							position="static"
							justify-content="flex-end"
						>
							<Override slot="cell-0">
								<Image
									src="https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23:27:39.399Z"
									display="block"
									height="50% content-box"
									overflow="visible"
									min-width="20%"
									width="60px"
									srcSet="https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23%3A27%3A39.399Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23%3A27%3A39.399Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23%3A27%3A39.399Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23%3A27%3A39.399Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23%3A27%3A39.399Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23%3A27%3A39.399Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/ICO%20logo.png?v=2025-08-30T23%3A27%3A39.399Z&quality=85&w=3200 3200w"
									sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
								/>
							</Override>
							<Override slot="cell-1">
								<Image
									src="https://uploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11:07:15.746Z"
									display="block"
									width="100px"
									srcSet="https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11%3A07%3A15.746Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11%3A07%3A15.746Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11%3A07%3A15.746Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11%3A07%3A15.746Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11%3A07%3A15.746Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11%3A07%3A15.746Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/68af6099eb72ed0019e83f3a/images/PropertyRedress.png?v=2025-09-03T11%3A07%3A15.746Z&quality=85&w=3200 3200w"
									sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
								/>
							</Override>
							<Override slot="Cell 0th" width="50px" />
						</Override>
					</Structure>
				</Box>
			</Box>
			<Text
				margin="0px 0px 0px 0px"
				font="normal 300 18px/1.5 --fontFamily-sans"
				color="#d7c7c5"
				md-margin="0px 0px 25px 0px"
				sm-text-align="center"
				text-align="center"
			>
				© 2025 Beesmoor Property Ltd. All rights reserved.
			</Text>
		</Section>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"68af6099eb72ed0019e83f38"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});